import { amcOnCautionYellowTheme, amcOnRedTheme, amcTheme, familyInsightsTheme, familyOnNeutralLighterAlt, familyTheme, xboxTheme} from "./themes";
import { PartialTheme, ThemeVariant } from "./types";

export const themeMap: { [key in ThemeVariant]: PartialTheme } = {
    AMC: amcTheme,
    "AMC-on-red": amcOnRedTheme,
    Family: familyTheme,
    FamilyInsights: familyInsightsTheme,
    "Family-On-NeutralLighterAlt": familyOnNeutralLighterAlt,
    XboxTheme: xboxTheme,
    "AMC-on-caution-yellow": amcOnCautionYellowTheme
};

export const themeList = ["AMC", "AMC-on-red", "Family", "FamilyInsights", "Family-On-NeutralLighterAlt", "XboxTheme", "AMC-on-caution-yellow"] as const;
